import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import { EmbedLookerChart } from '@components/EmbedLookerChart';
import AdvertiserContext from '@components/AdvertiserContext';
import { Themes } from '@constants/themes';
import { useLookerFiltersContext } from '@providers/LookerFiltersContext';
import ReportsSankey from '../pages/ReportsSankey';

const PathToPurchaseDashboards = {
  [Themes.DEFAULT]: 'P2P',
  [Themes.NBCU]: 'NBCU_P2P',
}

export const PathToPurchase = ({ setInExplore, internal }) => {
  const adContext = useContext(AdvertiserContext);
  const { filters, setFilters } = useLookerFiltersContext();

  const pathToPurchaseDashboard = useMemo(
    () => PathToPurchaseDashboards[adContext.theme],
    [adContext.theme]
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box mb={1}>
          <EmbedLookerChart
            id='path-to-purchase'
            dashboard={pathToPurchaseDashboard}
            withAuth={false}
            sx={{ height: 1100 }}
            filters={filters}
            setFilters={setFilters}
            setInExplore={setInExplore}
            internal={internal}
          />
        </Box>
        <ReportsSankey />
      </Grid>
    </Grid>
  );
};

PathToPurchase.propTypes = {
  setInExplore: PropTypes.func,
  internal: PropTypes.bool,
};
